import NavBar from "../Components/Common/navBar";
import Footer from "../Components/Common/footer";
import sustainabilityImage from "../Data/sustainabilityImage";
import ProductImages from "../Components/Common/productImages";

import "./styles/sustainability.css";

const Sustainability = () => {
    return (
        <div className="sustainabilityPage">
            <NavBar />
            <div className="sustainabilityContent">
                <div className="sustainabilityImage_1">
                    <img src="sustainabilityImages/main.jpg" alt="sustainability"></img>
                </div>
                <div className="sustainabilityParagraph">
                    <h2>Sustainability</h2>
                    
                    <img src="glitterpapereco.jpg" alt="sustainability"></img>
                    
                    <p>Everything we make has an impact on our people and our planet.  We are committed to minimizing our plastic and reducing its environmental impact on the environment.</p>
                    <p>We offer bamboo paper which is almost an infinitely renewable resource. Bamboo grows organically and can be harvested quickly. The plant absorbs up to four times more CO2 than some tree species.  Bamboo is also biodegradable and compostable.</p>
                    <p>In addition to Bamboo, we offer printing on recycled paper. Our commitment to fostering a circular economy extends to our paper products without print finishes, ensuring they are fully recyclable. Join us in supporting sustainable practices</p>
                    <p>If you need more information on how we make a difference, then please reach out to one of our team.</p>
                </div>
            </div>

            <div className="productImageGroup">
                <ProductImages picture={sustainabilityImage[1].picture} alt="sustainability" />
                <ProductImages picture={sustainabilityImage[2].picture} alt="sustainability" />
                <ProductImages picture={sustainabilityImage[3].picture} alt="sustainability" />
                <ProductImages picture={sustainabilityImage[4].picture} alt="sustainability" />
                <ProductImages picture={sustainabilityImage[5].picture} alt="sustainability" />
                <ProductImages picture={sustainabilityImage[6].picture} alt="sustainability" />
                <ProductImages picture={sustainabilityImage[7].picture} alt="sustainability" />
                <ProductImages picture={sustainabilityImage[8].picture} alt="sustainability" />
            </div>

            <Footer />
            
        </div>
    )
}

export default Sustainability